/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TranslationPreferenceFeature
 */
export interface TranslationPreferenceFeature {
    /**
     * 
     * @type {string}
     * @memberof TranslationPreferenceFeature
     */
    preference: TranslationPreferenceFeaturePreferenceEnum;
}


/**
 * @export
 */
export const TranslationPreferenceFeaturePreferenceEnum = {
    Manual: 'MANUAL',
    Auto: 'AUTO'
} as const;
export type TranslationPreferenceFeaturePreferenceEnum = typeof TranslationPreferenceFeaturePreferenceEnum[keyof typeof TranslationPreferenceFeaturePreferenceEnum];


/**
 * Check if a given object implements the TranslationPreferenceFeature interface.
 */
export function instanceOfTranslationPreferenceFeature(value: object): value is TranslationPreferenceFeature {
    if (!('preference' in value) || value['preference'] === undefined) return false;
    return true;
}

export function TranslationPreferenceFeatureFromJSON(json: any): TranslationPreferenceFeature {
    return TranslationPreferenceFeatureFromJSONTyped(json, false);
}

export function TranslationPreferenceFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationPreferenceFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'preference': json['preference'],
    };
}

export function TranslationPreferenceFeatureToJSON(value?: TranslationPreferenceFeature | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'preference': value['preference'],
    };
}

